import "react-phone-input-2/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import "styles/insurance.css";
import "styles/fonts.css";

import ExternalLinkHandler from "components/commons/ExternalLinkHandler";

// This default export is required in a new `pages/_app.js` file.
export default function MyApp ({ Component, pageProps }) {
  return (
    <>
      <ExternalLinkHandler />
      <Component {...pageProps} />
    </>
  );
}
